var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52 17.2567L12 14.6586L15.465 17.2567L14.145 13.0495L17.625 10.3333H13.365L12 6.18524L10.635 10.3333H6.375L9.84 13.0495L8.52 17.2567ZM24 11.8095C24 5.28476 18.63 0 12 0C5.37 0 0 5.28476 0 11.8095C0 14.8062 1.14 17.5224 3 19.6038V31L12 28.0476L21 31V19.6038C22.9341 17.4537 24.0013 14.6811 24 11.8095ZM12 2.95238C16.965 2.95238 21 6.92333 21 11.8095C21 16.6957 16.965 20.6667 12 20.6667C7.035 20.6667 3 16.6957 3 11.8095C3 6.92333 7.035 2.95238 12 2.95238ZM12 25.0952L6 26.601V22.0248C7.77 23.0286 9.81 23.619 12 23.619C14.19 23.619 16.23 23.0286 18 22.0248V26.601L12 25.0952Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.ce4a1fe8623c023f2b31e8f394e0f05c.svg";
export { ForwardRef as ReactComponent };